<template>
  <status-template
    :title="$t('title')"
    :description="$t('description')"
    :imageUrl="require(`@/assets/recipients-biometry/approved.svg`).default"
  />
</template>
<script>
export default {
  name: 'Approved',
  components: {
    StatusTemplate: () => import('./StatusTemplate.vue')
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Recebedor validado!",
      "description": "Agora você pode vender com este recebedor e movimentar o saldo com mais segurança."
    },
    "en-US": {
      "title": "Recipient validated",
      "description": "Now you can make sales with this recipient and change his balance with more security."
    }
  }
</i18n>
